import {
  getMenuItem,
  OPERATOR_DATA_SECTION,
  OPERATOR_OPS_GROUPS,
  OPERATOR_SUBSCRIPTIONS_SECTION,
} from './index'
import { SIDEBAR_MENU_AUDIENCE } from './sidebarMenuLayout'
import { isMenuItemVisible } from './menuVisibility'
import { sectionHasVisibleItems, simpleSectionHasVisibleItems } from '../../components/ShellMenuPanel'

function visibleItemsInGroup(group, ctx, audience) {
  return (group.itemIds || [])
    .map((id) => getMenuItem(id))
    .filter((item) => item && isMenuItemVisible(item, ctx, { audience }))
}

function pushSectionItems(blocks, sectionId, label, items) {
  if (items.length) blocks.push({ sectionId, label, items })
}

export function getSidebarMainItems(menuCtx) {
  const items = []
  const dashboard = getMenuItem('dashboard')
  if (menuCtx.showDashboard && dashboard) items.push(dashboard)

  const personalTaskBoard = getMenuItem('personal-task-board')
  if (personalTaskBoard && isMenuItemVisible(personalTaskBoard, menuCtx, { audience: SIDEBAR_MENU_AUDIENCE })) {
    items.push(personalTaskBoard)
  }
  return items
}

/** 사이드바 아코디언 섹션 (대시보드 제외) */
export function collectSidebarMenuBlocks(menuCtx, userSections) {
  const blocks = []
  const { isOperator } = menuCtx

  userSections.forEach((section) => {
    if (!menuCtx[section.visibilityKey]) return
    if (!sectionHasVisibleItems(section, menuCtx)) return
    const audience = section.audience || SIDEBAR_MENU_AUDIENCE
    const items = []
    ;(section.groups || []).forEach((group) => {
      items.push(...visibleItemsInGroup(group, menuCtx, audience))
    })
    pushSectionItems(blocks, section.id, section.label, items)
  })

  if (isOperator) {
    if (simpleSectionHasVisibleItems(OPERATOR_SUBSCRIPTIONS_SECTION.itemIds, menuCtx)) {
      const items = OPERATOR_SUBSCRIPTIONS_SECTION.itemIds
        .map((id) => getMenuItem(id))
        .filter((item) => item && isMenuItemVisible(item, menuCtx))
      pushSectionItems(blocks, 'subscriptions', OPERATOR_SUBSCRIPTIONS_SECTION.label, items)
    }
    if (menuCtx.showDataMgmtMenu) {
      const items = OPERATOR_DATA_SECTION.itemIds
        .map((id) => getMenuItem(id))
        .filter((item) => item && isMenuItemVisible(item, menuCtx))
      pushSectionItems(blocks, 'data', OPERATOR_DATA_SECTION.label, items)
    }
    if (menuCtx.showOpsMgmtMenu) {
      OPERATOR_OPS_GROUPS.forEach((group) => {
        const items = (group.itemIds || [])
          .map((id) => getMenuItem(id))
          .filter((item) => item && isMenuItemVisible(item, menuCtx))
        pushSectionItems(blocks, `ops-${group.title}`, group.title, items)
      })
    }
  }

  return blocks
}

export function findSidebarSectionForPath(blocks, pathname) {
  if (!pathname || pathname === '/') return null
  let bestSection = null
  let bestPath = null
  for (const block of blocks) {
    for (const item of block.items) {
      const path = item?.path
      if (!path || path === '/') continue
      if (pathname === path || pathname.startsWith(`${path}/`)) {
        if (!bestPath || path.length > bestPath.length) {
          bestPath = path
          bestSection = block.sectionId
        }
      }
    }
  }
  return bestSection
}
